module.exports = __webpack_public_path__ + "img/Bunga.d0e3da12.png";